import PropertyType from "./PropertyType";

export default PropertyType;
